import { toPairs, forEachObjIndexed } from 'ramda';
import { TOGGLE_DEBUG_MODE } from '../components/common/status/interfaces';

import { UrlParam, PaginationToUrlParams } from './interfaces';

export const convertArrayOptionsToUrlParam = (options: Record<string, string[]>): UrlParam[] => {
  const urlParams: UrlParam[] = [];

  forEachObjIndexed((value: string[], key: string) => {
    if (value) {
      value.forEach(item => {
        urlParams.push([key, item]);
      });
    }
  }, options);

  return urlParams;
};

export const convertOptionsToUrlParam = (options: Record<string, string>): UrlParam[] => toPairs(options);

export const convertPaginationOptionsToUrlParam = (props: PaginationToUrlParams) => convertOptionsToUrlParam(props);

export const getDocApiGuidePath = (page: string, guideSufix?: string) => {
  if (guideSufix) {
    return `${window.nortada.api.guide}/${page}/index.html#${guideSufix}`;
  }
  return `${window.nortada.api.guide}/${page}/index.html`;
};

export const getDocApiDocumentationPath = (page: string, replace: boolean = false) => {
  /* Hack to update link for USSD Session */
  if (replace) {
    const updatedLink = window.nortada.api.doc.replace('qrios-api', 'ussd-api');
    return `${updatedLink}/${page}`;
  }

  return `${window.nortada.api.doc}/${page}`;
};

export const convertBooleanToEnum = (props: boolean) =>
  props ? TOGGLE_DEBUG_MODE.ENABLED : TOGGLE_DEBUG_MODE.DISABLED;
